// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".car-age-total-red[data-v-10d86dc4]{color:#791f1f}", ""]);
// Exports
module.exports = exports;
